import URLUtils from "./utils/url_utils";

export default class QueryParam {
  static nextVideo(){
    if (typeof URLUtils.params()["next-video"] === "undefined") {
      return true;
    }

    return URLUtils.params()["next-video"] === "true";
  }

  static headerEnrichment() {
    if (typeof URLUtils.params()["header_enrichment"] === "undefined") {
      return false;
    }

    return URLUtils.params()["header_enrichment"] === "true";
  }

  static playerDebug() {
    if (typeof URLUtils.params()["player_debug"] === "undefined") {
      return false;
    }

    return URLUtils.params()["player_debug"] === "true";
  }
}
